import { MeterPointInfo } from "../../meters";
import { Address } from "..";
import { client } from "../../client";

export interface PropertyInfo {
  id: string;
  meterPoints: MeterPointInfo[];
  priorityServices: string[];
  address: Address;
}

export interface PropertiesResult {
  results: PropertyInfo[];
}

export const getAccountProperties = (
  queryKey: string,
  accountNumber: string | number,
) => {
  return client
    .get<PropertiesResult>(`accounts/${accountNumber}/properties`)
    .then((response) => response?.data);
};

export interface PropertyInfo {
  id: string;
  meterPoints: MeterPointInfo[];
  priorityServices: string[];
  vulnerabilities: string[];
  address: Address;
}
